import { LoaderMessage } from "../../../components/loaderMessage/loaderMessage";
import PdfRender from "../../../components/pdfRender/pdfRender";

interface DocumentsPaneProps {
  isFetchingDoc: boolean;
  errorInFetching: boolean;
  documents: File[];
  mergedPdfToRender: File | null;
}

const DocumentsPane = ({
  isFetchingDoc,
  errorInFetching,
  documents,
  mergedPdfToRender,
}: DocumentsPaneProps) => {
  const documentsToRender = mergedPdfToRender ? [mergedPdfToRender] : documents;
  return (
    <div className="pharma-questionaire-form__body-content--left ml-4 mr-4 mt-4 h-full flex-1 overflow-auto">
      {isFetchingDoc && <LoaderMessage message="Fetching documents..." />}
      {errorInFetching && "Error fetching document. Please try again later."}
      {!isFetchingDoc && documentsToRender && documentsToRender.length > 0 ? (
        documentsToRender.map((file, index) => (
          <PdfRender key={index} file={file} />
        ))
      ) : (
        <div className="pharma_questionaire-form__docs flex h-full items-center justify-center text-h10">
          No documents found
        </div>
      )}
    </div>
  );
};

export default DocumentsPane;
